import { c as _c } from "react/compiler-runtime";
import type { CreateAgentCredentialRequest } from '@onefootprint/request-types/dashboard';
import { Button, Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type FormValues = {
  name: string;
  token: string;
};
type CredentialOnePasswordFormProps = {
  pending: boolean;
  onSave: (body: CreateAgentCredentialRequest) => void;
};
const CredentialOnePasswordForm = t0 => {
  const $ = _c(42);
  const {
    pending,
    onSave
  } = t0;
  const {
    t
  } = useTranslation("copilot");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: DEFAULT_VALUES
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const formMethods = useForm(t1);
  let t2;
  if ($[1] !== onSave) {
    t2 = t3 => {
      const {
        name,
        token
      } = t3;
      onSave({
        provider: {
          kind: "one_password",
          serviceAccountToken: token.trim(),
          items: []
        },
        label: name.trim(),
        agentIds: [],
        temporary: false
      });
    };
    $[1] = onSave;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSubmit = t2;
  let t3;
  if ($[3] !== formMethods || $[4] !== onSubmit) {
    t3 = formMethods.handleSubmit(onSubmit);
    $[3] = formMethods;
    $[4] = onSubmit;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp2);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = {
      validate: value => String(value).trim().length > 0 || t(_temp3)
    };
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <Form.Input name="name" size="compact" label={t4} placeholder={t5} autoCorrect="off" autoFocus={true} required={true} rules={t6} />;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp4);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp5);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp6);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = {
      validate: value_0 => String(value_0).trim().startsWith(TOKEN_PREFIX) || t(_temp7)
    };
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
    t12 = <Form.Input name="token" size="compact" type="password" label={t8} placeholder={t9} hint={t10} autoComplete="off" required={true} data-dd-privacy="mask" rules={t11} />;
    $[24] = t10;
    $[25] = t11;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t(_temp8);
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== pending || $[32] !== t13) {
    t14 = <div><Button type="submit" variant="primary" size="compact" loading={pending}>{t13}</Button></div>;
    $[31] = pending;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t14 || $[36] !== t3 || $[37] !== t7) {
    t15 = <form className="flex flex-col gap-5" onSubmit={t3}>{t7}{t12}{t14}</form>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t3;
    $[37] = t7;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== formMethods || $[40] !== t15) {
    t16 = <FormProvider {...formMethods}>{t15}</FormProvider>;
    $[39] = formMethods;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  return t16;
};
const TOKEN_PREFIX = 'ops_';
const DEFAULT_VALUES: FormValues = {
  name: '',
  token: ''
};
export default CredentialOnePasswordForm;
function _temp($) {
  return $.chat.browser.credential.onePassword.name;
}
function _temp2($_0) {
  return $_0.chat.browser.credential.onePassword.namePlaceholder;
}
function _temp3($_1) {
  return $_1.chat.browser.credential.onePassword.nameRequired;
}
function _temp4($_2) {
  return $_2.chat.browser.credential.onePassword.token;
}
function _temp5($_3) {
  return $_3.chat.browser.credential.onePassword.tokenPlaceholder;
}
function _temp6($_4) {
  return $_4.chat.browser.credential.onePassword.tokenHint;
}
function _temp7($_5) {
  return $_5.chat.browser.credential.onePassword.tokenInvalid;
}
function _temp8($_6) {
  return $_6.chat.browser.credential.onePassword.submit;
}